import { createContext, useState } from 'react';
import api from 'services/api';

export const DivisaoCnaeContext = createContext();

export const DivisaoCnaeProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [divisaoCnae, setDivisaoCnae] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getDivisaoCnae = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: divisaoCnae?.filter,
        page: divisaoCnae?.page,
        size: divisaoCnae?.size,
        order: divisaoCnae?.order,
        ...payload,
      });
      setDivisaoCnae((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <DivisaoCnaeContext.Provider
      value={{
        getLoading,
        divisaoCnae,
        getDivisaoCnae,
      }}
    >
      {children}
    </DivisaoCnaeContext.Provider>
  );
};
